/* istanbul ignore file */
import React, { MouseEventHandler } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { toast } from 'react-toastify';
import SahamDrawer from 'components/SahamDrawer';
import { translate } from 'containers/services/translate';
import { EMPTY_ASSIGN_EXPERT_PROVISIORE } from 'containers/data-structure';
import messages from 'containers/CourtManagerLegalProceedings/messages';
import { ContainerInDrawer } from 'containers/LawyerFeeNote/styled-components';
import AssignExpertForm from 'containers/ProvisionalClaimRecap/Mission/AssignExpertForm';
import SahamDialog from 'components/SahamDialog';
import currentUserStorage from 'containers/services/security/current-user-storage';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { useDispatch, useSelector } from 'react-redux';
import { makeSelectCorporealExperts } from 'containers/RecapManagerPage/selectors';
import { requestCreateMission } from 'containers/ProvisionalClaimRecap/actions';
import { provisionalMissionType, VictimType } from 'typings/globalTypes';

export interface MissionDrawerProps {
  intl: IntlShape;
  open: boolean;
  handleToggleDrawer: Function;
  listings: any;
  assignedLawyer: any;
  provisionnalClaimId: any;
  victims: Partial<VictimType>[];
}

const MissionDrawer: React.FC<MissionDrawerProps> = (props): JSX.Element => {
  const dispatch = useDispatch();
  const corporealExperts = useSelector(makeSelectCorporealExperts());
  const [assignExpert, setAssignExpert] = React.useState({
    ...EMPTY_ASSIGN_EXPERT_PROVISIORE,
  });
  const [isDialogOpen, setIsDialogOpen] = React.useState<boolean>(false);

  const handleValidation = () => {
    dispatch(
      requestCreateMission(
        ({
          ...assignExpert,
          provisionalClaimId: props.provisionnalClaimId,
          isTrackingActive: featureService.hasFeature(
            FEATURES.TRACKING_ACTIONS_USER,
          ),
          createdBy: currentUserStorage?.get().username,
        } as unknown) as provisionalMissionType,
        successCallBack,
      ),
    );
    props.handleToggleDrawer();
  };

  const successCallBack = () => {
    toast.success(translate(messages.successTitleAssign, props));
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  const handleOpenDialog = () => {
    setIsDialogOpen(true);
  };
  return (
    <SahamDrawer
      open={props.open}
      handleToggleDrawer={props.handleToggleDrawer}
      title={translate({ ...messages.ExpertDrawerTitle }, props, {
        number: null,
      })}
      handleValidateDrawer={handleOpenDialog}
      confirmButtonTitle={translate(messages.AssignButton, props)}
      isSaveButtonDisabled={false}
    >
      <ContainerInDrawer>
        <AssignExpertForm
          assignExpert={assignExpert}
          setAssignExpertFields={setAssignExpert}
          listings={props.listings}
          corporealLawyers={[]}
          corporealExperts={corporealExperts}
          victims={props.victims}
        />
      </ContainerInDrawer>
      <SahamDialog
        handleValidate={handleValidation}
        handleClose={handleCloseDialog as MouseEventHandler}
        title={translate(messages.courtManagerConfirmationDialogTitle, props)}
        cancelTitle={translate(
          messages.courtManagerConfirmationDialogCancel,
          props,
        )}
        confirmTitle={translate(
          messages.courtManagerConfirmationDialogConfirm,
          props,
        )}
        open={isDialogOpen}
      >
        {translate(messages.courtManagerConfirmationDialogContent, props)}
      </SahamDialog>
    </SahamDrawer>
  );
};

export default injectIntl(MissionDrawer);
